import Vue from 'vue';
import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  availableProcesses: [],
  allProcesses: [],
  runningProcesses: [],
  runningProcessesCount: null,
  instanceId: '',
  origInstanceId: '',
  definitionId: '',
  deletedInstanceId: '',
  completedInstances: [],
  deployedProcess: [],
  processAction: '',
  processId: '',
  deploymentName: '',
  processXml: '',
  deletedDeploymentId: '',
  savedProcess: [],
  savedExternalProcess: [],
  allProcessXml: [],
  allExternalProcessXml: [],
  savedProcessXml: '',
  deploymentSuccess: false,
  deletedXmlId: '',
  latestVersions: [],
  updatedXmlVersion: false,
  setCaseId: null,
  setCaseLabel: null,
  getCaseId: null,
  getCaseLabel: null,
  allCaseLabels: null,
  newCaseId: null,
  processCount: null,
  historicVariables: [],
  historicCaseId: '',
  deletedVariable: '',
  bulkDeletion: '',
  processSelections: {},
  importXml: null,
  caseStatus: null,
  statusGet: '',
  statusUpdate: '',
  caseDataDeleted: '',
  editingProcess: false,
  processLocked: false,
  processLockedUser: '',
  processMap: null,
  activityInstance: null,
  savedStartedBefore: '',
  savedStartedAfter: '',
  savedFinishedBefore: '',
  savedFinishedAfter: '',
  histDatesCleared: false,
  migrationSuccess: false,
  setVarSuccess: false
};

const getters = {
  availableProcesses: (state) => state.availableProcesses,
  allProcesses: (state) => state.allProcesses,
  runningProcesses: (state) => state.runningProcesses,
  runningProcessesCount: (state) => state.runningProcessesCount,
  instanceId: (state) => state.instanceId,
  origInstanceId: (state) => state.origInstanceId,
  definitionId: (state) => state.definitionId,
  completedInstances: (state) => state.completedInstances,
  processAction: (state) => state.processAction,
  processId: (state) => state.processId,
  deploymentName: (state) => state.deploymentName,
  processXml: (state) => state.processXml,
  allProcessXml: (state) => state.allProcessXml,
  allExternalProcessXml: (state) => state.allExternalProcessXml,
  savedProcessXml: (state) => state.savedProcessXml,
  deploymentSuccess: (state) => state.deploymentSuccess,
  latestVersions: (state) => state.latestVersions,
  getCaseId: (state) => state.getCaseId,
  getCaseLabel: (state) => state.getCaseLabel,
  allCaseLabels: (state) => state.allCaseLabels,
  setCaseLabel: (state) => state.setCaseLabel,
  processCount: (state) => state.processCount,
  historicVariables: (state) => state.historicVariables,
  historicCaseId: (state) => state.historicCaseId,
  newCaseId: (state) => state.newCaseId,
  processSelections: (state) => state.processSelections,
  importXml: (state) => state.importXml,
  processLocked: (state) => state.processLocked,
  processLockedUser: (state) => state.processLockedUser,
  processMap: (state) => state.processMap,
  activityInstance: (state) => state.activityInstance,
  savedStartedBefore: (state) => state.savedStartedBefore,
  savedStartedAfter: (state) => state.savedStartedAfter,
  savedFinishedBefore: (state) => state.savedFinishedBefore,
  savedFinishedAfter: (state) => state.savedFinishedAfter,
  histDatesCleared: (state) => state.histDatesCleared,
  migrationSuccess: (state) => state.migrationSuccess,
  setVarSuccess: (state) => state.setVarSuccess
};

const actions = {
  // Get all startable processes
  getProcesses({commit}) {

    return axios.get(baseURL + '/process-definition?startableInTasklist=true&startablePermissionCheck=true&latestVersion=true&startableBy=' + store.state.currentUser, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('PROCESSES', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllProcesses({commit}) {

    return axios.get(baseURL + '/process-definition', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      
      let processes = [];
      for(let i = 0; i < result.data.length; i++) {
        if(!result.data[i].key.includes('Controller')) {
          processes.push(result.data[i]);
        }
      }

      let latestVersions = [];
      for(let j = 0; j < processes.length; j++) {
        if(latestVersions.length === 0) {
          latestVersions[processes[j].key] = processes[j].version;
        }else {
          if(latestVersions[processes[j].key]) {
            if(processes[j].version > latestVersions[processes[j].key]) {
              latestVersions[processes[j].key] = processes[j].version;
            }
          }else {
            latestVersions[processes[j].key] = processes[j].version;
          }
        }
      }
      
      commit('LATEST_VERSIONS', latestVersions);
      commit('PROCESS_COUNT', processes.length);
      commit('ALL_PROCESSES', processes);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getProcessXml({commit}, processId) {

    return axios.get(baseURL + '/process-definition/' + processId + '/xml', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('PROCESS_XML', result.data.bpmn20Xml);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getProcessInstances({rootState, commit}) {
    let ref = this;

    return axios.get(baseURL + '/process-instance', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      const PromiseArr = [];
      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          PromiseArr.push(
            axios.get(baseURL + '/process-definition?processDefinitionId=' + result.data[i].definitionId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => 
              resolve(resp.data[0].name)))
          );
        }
      }

      Promise.all(PromiseArr).then(res => {
        
        res.forEach(function(item, index) {
          // Check for a case ID, if null get one
          if(result.data[index].businessKey == null) {
            let payload = {
              'instanceId': result.data[index].id,
              'processId': result.data[index].definitionId
            };
            ref.dispatch('setCaseId', payload).then( () => {
              ref.dispatch('getCaseId', result.data[index].id).then( () => {
                Vue.set(result.data[index], 'caseId', rootState.process.getCaseId);
              });
            });
          }else {
            Vue.set(result.data[index], 'caseId', result.data[index].businessKey);
          }
          Vue.set(result.data[index], 'processName', item);
        });
        
        commit('RUNNING_PROCESSES_COUNT', result.data.length);
        commit('RUNNING_PROCESSES', result.data);
      });
      
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async startProcess({rootState, state, commit}, payload) {
    let caseLabel = payload.caseLabel;
    let startVars = {
      'variables': {
        'currentUser': { 'value': payload.currentUser, 'type': 'String' },
        'currentUserFullname': { 'value': payload.currentUserFullname, 'type': 'String' },
        'currentUserEmail': { 'value': payload.currentUserEmail, 'type': 'String' },
        'users': { 'value': payload.users, 'type': 'Json' },
        'groups': { 'value': payload.groups, 'type': 'Json' }
      },
      'withVariablesInReturn': true,
      'businessKey': state.newCaseId
    }

    // Get any additional starter variables
    await this.dispatch('getStarterVars', payload.key).then( () => {
      if(rootState.tables.starterVars.value) {
        let starterVars = JSON.parse(rootState.tables.starterVars.value);

        for(let i = 0; i < starterVars.length; i++) {
          let varName = starterVars[i].varName;
          let varValue = starterVars[i].varValue;
          let varType = starterVars[i].varType;

          if(varType == 'Integer') {
            varValue = parseInt(varValue);
          }

          if(varType == 'Boolean') {
            if(varValue == 'true') {
              varValue = true;
            }else {
              varValue = false;
            }
          }

          if(varType == 'Json') {
            varValue = JSON.stringify(varValue);
          }

          startVars.variables[varName] = { 'value': varValue, 'type': varType };
        }
      }
          
      return axios.post(baseURL + '/process-definition/key/' + payload.key + '/tenant-id/harlequin/start', startVars, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
        let payload = {
          'instanceId': result.data.id,
          'processId': result.data.definitionId,
          'caseLabel': caseLabel
        };
        this.dispatch('setCaseId', payload);
        commit('PROCESS_DATA', result.data);
      }).catch(error => {
        throw new Error(`API ${error}`);
      });
    });
  },
  startExternalProcess({state, commit}, payload) {
    let caseLabel = payload.caseLabel;
    return axios.post(baseURL + '/process-definition/key/' + payload.key + '/tenant-id/harlequin/start', { businessKey: state.newCaseId }, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      let payload = {
        'instanceId': result.data.id,
        'processId': result.data.definitionId,
        'caseLabel': caseLabel
      };
      this.dispatch('setExternalCaseId', payload);
      commit('PROCESS_DATA', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteProcessInstance({commit}, payload) {
    return axios.delete(baseURL + '/process-instance/' + payload.id + '?skipCustomListeners=true&skipIoMappings=true', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        this.dispatch('deleteCaseData', payload.id);
        commit('DELETED_INSTANCE_ID', payload.id);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteHistoricProcessInstance({commit}, payload) {
    return axios.delete(baseURL + '/history/process-instance/' + payload.id, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        commit('DELETED_INSTANCE_ID', payload.id);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  bulkDeleteHistoricProcessInstance({commit}, payload) {
    const PromiseArr = [];
    const items = payload.items;
    for(let i = 0; i < items.length; i++) {
      PromiseArr.push(
        axios.delete(baseURL + '/history/process-instance/' + items[i].id, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => 
          resolve(resp.status)))
      );
    }

    Promise.all(PromiseArr).then(res => {
      let success = true;
      res.forEach(function(item) {
        if(item != 204) {
          success = false;
        }
      });
      
      commit('BULK_DELETION', success);
    });
  },
  getCompletedInstances({rootState, commit}, payload) {
    let endpoint = '/history/process-instance?processDefinitionKeyNotIn=formController,fileController,emailController,templateController,processController,databaseController,documentController,sqlController,apiController,userController,supportController,ssoController,ldapController';
    if(payload.startedBefore) {
      endpoint += '&startedBefore=' + encodeURIComponent(payload.startedBefore);
    }
    if(payload.startedAfter) {
      endpoint += '&startedAfter=' + encodeURIComponent(payload.startedAfter);
    }
    if(payload.finishedBefore) {
      endpoint += '&finishedBefore=' + encodeURIComponent(payload.finishedBefore);
    }
    if(payload.finishedAfter) {
      endpoint += '&finishedAfter=' + encodeURIComponent(payload.finishedAfter);
    }
    
    return axios.get(baseURL + endpoint, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {     
      let instances = [];
      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          if(!result.data[i].processDefinitionKey.includes('Controller')) {
            if(result.data[i].businessKey == null) {
              this.dispatch('getCaseId', result.data[i].rootProcessInstanceId).then( () => {
                Vue.set(result.data[i], 'caseId', rootState.process.getCaseId);
              });
            }else {
              Vue.set(result.data[i], 'caseId', result.data[i].businessKey);
            }
            // Format date
            let sdate = new Date(result.data[i].startTime);
            Vue.set(result.data[i], 'startTime', new Intl.DateTimeFormat('en-GB', 
              {
                day: 'numeric',
                month: 'numeric', 
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false
              }).format(sdate));
            let edate = new Date(result.data[i].endTime);
            if(edate.toString().includes('1970')) {
              Vue.set(result.data[i], 'endTime', '')
            }else {
              Vue.set(result.data[i], 'endTime', new Intl.DateTimeFormat('en-GB', 
                {
                  day: 'numeric',
                  month: 'numeric', 
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                  hour12: false
                }).format(edate));
              }
            
              instances.push(result.data[i]);
          }
        }
        commit('COMPLETED_INSTANCES', instances);
      }else {
        commit('COMPLETED_INSTANCES', []);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getHistoricVariables({commit}, payload) {
    return axios.get(baseURL + '/history/variable-instance?processInstanceId=' + payload.processInstanceId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.status == 200) {
        commit('HISTORIC_VARIABLES', result.data);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteHistoricVariable({commit}, id) {
    return axios.delete(baseURL + '/history/variable-instance/' + id, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.status == 204) {
        commit('DELETED_VARIABLE', id);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deployProcess({commit}, form) {
    return axios.post(baseURL + '/deployment/create', form, {headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.status == 200) {
        commit('DEPLOYED_PROCESS', result.data);
        commit('DEPLOYMENT_SUCCESS', true);
      }else {
        commit('DEPLOYMENT_SUCCESS', false);
      }
    }).catch(error => {
      commit('DEPLOYMENT_SUCCESS', false);
      throw new Error(`API ${error}`);
    });
  },
  deleteDeployment({commit}, payload) {
    return axios.delete(baseURL + '/deployment/' + payload.id + '?cascade=true&skipCustomListeners=true&skipIoMappings=true', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.status == 204) {
        this.dispatch('deleteProcessData', payload.processId);
        commit('DELETED_DEPLOYMENT_ID', payload.id);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveProcessXml({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'xml', 'type': 'String' },
        'action': { 'value': 'save', 'type': 'String' },
        'name': { 'value': payload.name, 'type': 'String' },
        'processName': { 'value': payload.processName, 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'xml': { 'value': payload.xml, 'type': 'Xml' },
        'version': { 'value': payload.version, 'type': 'Integer' },
        'selections': { 'value': payload.selections, 'type': 'Json' },
        'isLocked': { 'value': payload.isLocked, 'type': 'Integer' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('SAVED_PROCESS', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  saveExternalProcessXml({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'xml', 'type': 'String' },
        'action': { 'value': 'save', 'type': 'String' },
        'name': { 'value': payload.name, 'type': 'String' },
        'processName': { 'value': payload.processName, 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'xml': { 'value': payload.xml, 'type': 'Xml' },
        'version': { 'value': payload.version, 'type': 'Integer' },
        'selections': { 'value': payload.selections, 'type': 'Json' },
        'isLocked': { 'value': payload.isLocked, 'type': 'Integer' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(payload.engine + '/engine-rest/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('SAVED_EXTERNAL_PROCESS', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllProcessXml({commit}) {
    let data = {
      'variables': {
        'pType': { 'value': 'xml', 'type': 'String' },
        'action': { 'value': 'getAll', 'type': 'String' },
        'version': { 'value': 0, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let allXml = JSON.parse(result.data.variables.allXml.value);
      commit('ALL_PROCESS_XML', allXml);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  async getAllExternalProcessXml({commit, rootState}) {
    await this.dispatch('getAllHqConnections').then( () => {
      const PromiseArr = [];
      let conns = rootState.admin.allHqConns;
      let extXmls = [];
      let data = {
        'variables': {
          'pType': { 'value': 'xml', 'type': 'String' },
          'action': { 'value': 'getAll', 'type': 'String' },
          'version': { 'value': 0, 'type': 'Integer' }
        },
        'withVariablesInReturn': true
      }
      for(let i = 0; i < conns.length; i++) {
        PromiseArr.push(
          axios.post(conns[i].URL + '/engine-rest/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => new Promise(resolve => 
            resolve(JSON.parse(result.data.variables.allXml.value))))
        );
      }

      Promise.all(PromiseArr).then(res => {
        res.forEach(function(item, index) {
          item['ENGINE'] = conns[index].ENGINE_NAME;
          extXmls.push(item);
        });
        
        commit('ALL_EXTERNAL_PROCESS_XML', extXmls);
      });
    });
  },
  getSavedProcessXml({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'xml', 'type': 'String' },
        'action': { 'value': 'get', 'type': 'String' },
        'lockedBy': { 'value': payload.lockedBy, 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'version': { 'value': payload.version, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let xml = JSON.parse(result.data.variables.xml.value);
      let selections = JSON.parse(JSON.parse(result.data.variables.selections.value));
      commit('SAVED_PROCESS_XML', xml);
      commit('PROCESS_SELECTIONS', selections);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteProcessXml({commit}, xmlId) {
    let data = {
      'variables': {
        'pType': { 'value': 'xml', 'type': 'String' },
        'action': { 'value': 'delete', 'type': 'String' },
        'xmlId': { 'value': xmlId, 'type': 'Integer' },
        'version': { 'value': 0, 'type': 'Integer' }
      }
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('DELETED_PROCESS_XML', xmlId);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  updateXmlVersion({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'xml', 'type': 'String' },
        'action': { 'value': 'updateVersion', 'type': 'String' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'version': { 'value': payload.version, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('UPDATED_XML_VERSION', true);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getProcessMap({commit}, id) {
    return axios.get(baseURL + '/process-definition/' + id + '/xml', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.status == 200) {
        commit('PROCESS_MAP', result.data.bpmn20Xml);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getInstanceActivity({commit}, id) {
    return axios.get(baseURL + '/history/activity-instance?sortBy=startTime&sortOrder=asc&processInstanceId=' + id, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.status == 200) {
        commit('ACTIVITY_INSTANCE', result.data);
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  setCaseId({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'save', 'type': 'String' },
        'instanceId': { 'value': payload.instanceId, 'type': 'String' },
        'processId': { 'value': payload.processId, 'type': 'String' },
        'caseLabel': { 'value': payload.caseLabel, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('SET_CASE_ID', payload.instanceId);
      commit('SET_CASE_LABEL', payload.caseLabel);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  setExternalCaseId({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'save', 'type': 'String' },
        'instanceId': { 'value': payload.instanceId, 'type': 'String' },
        'processId': { 'value': payload.processId, 'type': 'String' },
        'caseLabel': { 'value': payload.caseLabel, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( () => {
      commit('SET_CASE_ID', payload.instanceId);
      commit('SET_CASE_LABEL', payload.caseLabel);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getCaseLabelById({commit}, caseId) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'getLabel', 'type': 'String' },
        'caseId': { 'value': caseId, 'type': 'Integer' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      commit('GET_CASE_LABEL', result.data.variables.caseLabel.value);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllCaseLabels({commit}, instIds) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'getLabels', 'type': 'String' },
        'instIds': { 'value': instIds, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      commit('ALL_CASE_LABEL', result.data.variables.caseLabels.value);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getCaseId({commit}, instanceId) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'get', 'type': 'String' },
        'instanceId': { 'value': instanceId, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      commit('GET_CASE_ID', result.data.variables.caseId.value);
      commit('GET_CASE_LABEL', result.data.variables.caseLabel.value);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getNewCaseId({commit}) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'getNew', 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('NEW_CASE_ID', result.data.variables.newCaseId.value);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  setCaseStatus({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'setStatus', 'type': 'String' },
        'instanceId': { 'value': payload.instanceId, 'type': 'String' },
        'opened': { 'value': payload.opened, 'type': 'Boolean' },
        'caseId': { 'value': payload.caseId, 'type': 'String' },
        'taskId': { 'value': payload.taskId, 'type': 'String' },
        'assignee': { 'value': payload.assignee, 'type': 'String' }
      }
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('STATUS_SET', payload.opened);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getCaseStatus({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'getStatus', 'type': 'String' },
        'instanceId': { 'value': payload.instanceId, 'type': 'String' },
        'processId': { 'value': payload.processId, 'type': 'String' },
        'caseId': { 'value': payload.caseId, 'type': 'String' },
        'taskId': { 'value': payload.taskId, 'type': 'String' },
        'assignee': { 'value': payload.assignee, 'type': 'String' }
      }
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('STATUS_GET', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  updateCaseLabel({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'updateLabel', 'type': 'String' },
        'caseId': { 'value': payload.caseId, 'type': 'Integer' },
        'caseLabel': { 'value': payload.caseLabel, 'type': 'String' }
      },
      'withVariablesInReturn': true
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('SET_CASE_LABEL', payload.caseLabel);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  updateAssignee({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'updateAssignee', 'type': 'String' },
        'instanceId': { 'value': payload.instanceId, 'type': 'String' },
        'opened': { 'value': payload.opened, 'type': 'Boolean' },
        'caseId': { 'value': payload.caseId, 'type': 'String' },
        'taskId': { 'value': payload.taskId, 'type': 'String' },
        'assignee': { 'value': payload.assignee, 'type': 'String' }
      }
    }

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('STATUS_UPDATE', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteCaseData({commit}, instanceId) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'deleteData', 'type': 'String' },
        'instanceId': { 'value': instanceId, 'type': 'String' }
      }
    };

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('CASE_DATA_DELETED', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteProcessData({commit}, processId) {
    let data = {
      'variables': {
        'pType': { 'value': 'case', 'type': 'String' },
        'action': { 'value': 'deleteProcessData', 'type': 'String' },
        'processId': { 'value': processId, 'type': 'String' }
      }
    };

    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('CASE_DATA_DELETED', 'success');
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  processLockCheck({commit}, payload) {
    let data = {
      'variables': {
        'pType': { 'value': 'lockCheck', 'type': 'String' },
        'processId': { 'value': payload.processId, 'type': 'Integer' },
        'processKey': { 'value': payload.processKey, 'type': 'String' },
        'checkType': { 'value': payload.checkType, 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {      
      let retData = {
        'processLocked': result.data.variables.processLocked.value,
        'processLockedUser': result.data.variables.processLockedUser.value
      };
      commit('PROCESS_LOCK_CHECK', retData);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  unlockAll() {
    let data = {
      'variables': {
        'pType': { 'value': 'lockCheck', 'type': 'String' },
        'processId': { 'value': 0, 'type': 'Integer' },
        'lockedByUser': { 'value': store.state.currentUser, 'type': 'String' },
        'checkType': { 'value': 'unlockAll', 'type': 'String' }
      },
      'withVariablesInReturn': true
    };
    return axios.post(baseURL + '/process-definition/key/processController/start', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {      
      // Do nothing
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  migrateCases({commit}, payload) {
    // Generate migration plan
    let data = {
      'sourceProcessDefinitionId': payload.sourceProcessDefId,
      'targetProcessDefinitionId': payload.targetProcessDefId,
      'updateEventTriggers': true
    }
    return axios.post(baseURL + '/migration/generate', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( plan => {
      // Execute migration plan
      let migrationData = {
        'migrationPlan': plan.data,
        'processInstanceIds': payload.targetInstances
      }
      // let migrationData = {
      //   'migrationPlan': plan.data,
      //   'processInstanceQuery': {
      //     'processDefinitionId': payload.sourceProcessDefId
      //   }
      // }
      return axios.post(baseURL + '/migration/execute', migrationData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
        commit('MIGRATION_SUCCESS', true);

        // Update process IDs in RSL_CASES
        let instanceIds = JSON.stringify(payload.targetInstances);
        instanceIds = instanceIds.replace(/\[/g, '(');
        instanceIds = instanceIds.replace(/\]/g, ')');
        let theSql = 'UPDATE RSL_CASES SET PROCESS_ID = "' + payload.targetProcessDefId + '" WHERE INSTANCE_ID IN ' + instanceIds;
        let tableData = {
          'connId': 0,
          'theSql': theSql
        }
        this.dispatch('executeSqlOther', tableData);
      }).catch(error => {
        commit('MIGRATION_SUCCESS', false);
        throw new Error(`API ${error}`);
      });
    }).catch(error => {
      commit('MIGRATION_SUCCESS', false);
      throw new Error(`API ${error}`);
    });
  },
  setVariables({commit}, payload) {
    let varName = payload.varName;
    let varValue = payload.varValue;

    if(payload.varType == 'Boolean') {
      if(varValue == 'true') {
        varValue = true;
      }else {
        varValue = false;
      }
    }

    if(payload.varType == 'Json') {
      varValue = JSON.stringify(varValue);
    }

    for(let i = 0; i < payload.targetInstances.length; i++) {
      let data = {
        "modifications": {
        }
      }
      data.modifications[varName] = { "value": varValue, "type": payload.varType }

      axios.post(baseURL + '/process-instance/' + payload.targetInstances[i] + '/variables', data, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
        if(result.status == 204) {
          commit('SET_VAR_SUCCESS', true);
        }
      }).catch(error => {
        commit('SET_VAR_SUCCESS', false);
        throw new Error(`API ${error}`);
      });
    }
  }
};

const mutations = {
  PROCESSES(state, payload) {
    state.availableProcesses = payload;
  },
  ALL_PROCESSES(state, payload) {
    state.allProcesses = payload;
  },
  PROCESS_COUNT(state, payload) {
    state.processCount = payload;
  },
  RUNNING_PROCESSES(state, payload) {
    state.runningProcesses = payload;
  },
  RUNNING_PROCESSES_COUNT(state, payload) {
    state.runningProcessesCount = payload;
  },
  PROCESS_DATA(state, payload) {
    state.instanceId = payload.id;
    state.definitionId = payload.definitionId;
  },
  UPDATE_DEFINITION_ID(state, payload) {
    state.definitionId = payload;
  },
  UPDATE_INSTANCE_ID(state, payload) {
    state.instanceId = payload;
  },
  UPDATE_ORIG_INSTANCE_ID(state, payload) {
    state.origInstanceId = payload;
  },
  DELETED_INSTANCE_ID(state, payload) {
    state.deletedInstanceId = payload;
  },
  COMPLETED_INSTANCES(state, payload) {
    state.completedInstances = payload;
  },
  DEPLOYED_PROCESS(state, payload) {
    state.deployedProcess = payload;
  },
  UPDATE_PROCESS_ACTION(state, payload) {
    state.processAction = payload;
  },
  UPDATE_PROCESS_ID(state, payload) {
    state.processId = payload;
  },
  UPDATE_DEPLOYMENT_NAME(state, payload) {
    state.deploymentName = payload;
  },
  PROCESS_XML(state, payload) {
    state.processXml = payload;
  },
  ALL_PROCESS_XML(state, payload) {
    state.allProcessXml = payload;
  },
  ALL_EXTERNAL_PROCESS_XML(state, payload) {
    state.allExternalProcessXml = payload;
  },
  DELETED_DEPLOYMENT_ID(state, payload) {
    state.deletedDeploymentId = payload;
  },
  SAVED_PROCESS(state, payload) {
    state.savedProcess = payload;
  },
  SAVED_EXTERNAL_PROCESS(state, payload) {
    state.savedExternalProcess = payload;
  },
  SAVED_PROCESS_XML(state, payload) {
    state.savedProcessXml = payload;
  },
  DEPLOYMENT_SUCCESS(state, payload) {
    state.deploymentSuccess = payload;
  },
  DELETED_PROCESS_XML(state, payload) {
    state.deletedXmlId = payload;
  },
  LATEST_VERSIONS(state, payload) {
    state.latestVersions = payload;
  },
  UPDATED_XML_VERSION(state, payload) {
    state.updatedXmlVersion = payload;
  },
  SET_CASE_ID(state, payload) {
    state.setCaseId = payload;
  },
  SET_CASE_LABEL(state, payload) {
    state.setCaseLabel = payload;
  },
  GET_CASE_ID(state, payload) {
    state.getCaseId = payload;
  },
  GET_CASE_LABEL(state, payload) {
    state.getCaseLabel = payload;
  },
  ALL_CASE_LABEL(state, payload) {
    state.allCaseLabels = payload;
  },
  NEW_CASE_ID(state, payload) {
    state.newCaseId = payload;
  },
  STATUS_SET(state, payload) {
    state.caseStatus = payload;
  },
  STATUS_GET(state, payload) {
    state.statusGet = payload;
  },
  STATUS_UPDATE(state, payload) {
    state.statusUpdate = payload;
  },
  HISTORIC_VARIABLES(state, payload) {
    state.historicVariables = payload;
  },
  UPDATE_HISTORIC_CASE_ID(state, payload) {
    state.historicCaseId = payload;
  },
  DELETED_VARIABLE(state, payload) {
    state.deletedVariable = payload;
  },
  BULK_DELETION(state, payload) {
    state.bulkDeletion = payload;
  },
  PROCESS_SELECTIONS(state, payload) {
    state.processSelections = payload;
  },
  UPDATE_IMPORT_XML(state, payload) {
    state.importXml = payload;
  },
  CASE_DATA_DELETED(state, payload) {
    state.caseDataDeleted = payload;
  },
  EDITING_PROCESS(state, payload) {
    state.editingProcess = payload;
  },
  PROCESS_LOCK_CHECK(state, payload) {
    state.processLocked = payload.processLocked;
    state.processLockedUser = payload.processLockedUser;
  },
  PROCESS_MAP(state, payload) {
    state.processMap = payload;
  },
  ACTIVITY_INSTANCE(state, payload) {
    state.activityInstance = payload;
  },
  SAVED_STARTED_BEFORE(state, payload) {
    state.savedStartedBefore = payload;
  },
  SAVED_STARTED_AFTER(state, payload) {
    state.savedStartedAfter = payload;
  },
  SAVED_FINISHED_BEFORE(state, payload) {
    state.savedFinishedBefore = payload;
  },
  SAVED_FINISHED_AFTER(state, payload) {
    state.savedFinishedAfter = payload;
  },
  HIST_DATES_CLEARED(state, payload) {
    state.histDatesCleared = payload;
  },
  MIGRATION_SUCCESS(state, payload) {
    state.migrationSuccess = payload;
  },
  SET_VAR_SUCCESS(state, payload) {
    state.setVarSuccess = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}